module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icn-campany-management-7466d94e3926285f94241083cc578f59.svg";